import * as types from './types'

export default {
  [types.RESET_BLOGS](state, firm) {
    state.blogs = []
    state.comments = []
    state.blogStatus = null
    state.blogType = null
    state.blog = JSON.parse(JSON.stringify(state.defaultBlog))
    state.blog.firm = firm
    state.comment = null
  },
  [types.RESET_COMMENTS](state) {
    state.comments = []
  },
  [types.RESET_ATTACHMENTS](state) {
    state.attachments = []
  },
  [types.INIT_BLOG](state, firm) {
    state.blog = JSON.parse(JSON.stringify(state.defaultBlog))
    state.blog.firm = firm
  },
  [types.INIT_COMMENT](state, blog) {
    state.comment = JSON.parse(JSON.stringify(state.defaultComment))
    state.comment.blog = blog
  },
  [types.SET_SEARCH_TERM](state, searchTerm) {
    state.searchTerm = searchTerm
  },
  [types.SET_STATUS](state, status) {
    state.blogStatus = status
  },
  [types.SET_TYPE](state, type) {
    state.blogType = type
    console.log('Set Type', state.blogType)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
  },
  [types.SET_SORT_BY](state, sortBy) {
    state.sortBy = sortBy
  },
  [types.RESET_SHOW](state, data) {
    if (state.blogs) {
      state.blogs.forEach(element => {
        element.id++
        element.showComment = false
        element.showAttachment = false
        if (parseInt(element.blog) === parseInt(data.blog)) {
          if (data.showAttachment) {
            element.showAttachment = true
          } else if (data.showComment) {
            element.showComment = true
          }
        }
      })
    }
  },
  [types.UPDATE_BLOG](state, data) {
    if (state.blog) {
      switch (data.name) {
        case 'firm':
          state.blog.firm = parseInt(data.value)
          break
        case 'blogType':
          state.blog.blogType = parseInt(data.value)
          break
        case 'blogStatus':
          state.blog.blogStatus = parseInt(data.value)
          break
        case 'blogName':
          state.blog.blogName = data.value
          break
        case 'createdBy':
          state.blog.createdBy = parseInt(data.value)
          break
        case 'content':
          state.blog.content = data.value
          break
        case 'imageUrl':
          state.blog.imageUrl = data.value
          break
        case 'blogTags':
          state.blog.blogTags = data.value
          break
        case 'scheduledOn':
          state.blog.scheduledOn = data.value
          break
        case 'isSticky':
          state.blog.isSticky = data.value
          break
        case 'sort':
          state.blog.sort = parseInt(data.value)
          break
        case 'isIncludeShop':
          state.blog.isIncludeShop = data.value
          break
        case 'isAllowComments':
          state.blog.isAllowComments = data.value
          break
      }
    }
  },
  [types.UPDATE_COMMENT](state, data) {
    if (state.comment) {
      switch (data.name) {
        case 'blog':
          state.blog.blog = parseInt(data.value)
          break
        case 'createdBy':
          state.blog.createdBy = parseInt(data.value)
          break
        case 'content':
          state.blog.content = data.value
          break
      }
    }
  },
  [types.SET_BLOGS](state, data) {
    let cnt = 0
    state.blogCount = 0
    state.blogs = []
    if (data) {
      if (data !== '') {
        state.blogCount = parseInt(data.count)
        state.blogs = data.items
        if (state.blogs) {
          state.blogs.forEach(element => {
            element.id = cnt
            element.showComment = false
            element.showAttachment = false
            cnt++
          })
        }
      }
    }
  },
  [types.SET_BLOG](state, data) {
    state.blog = data
  },
  [types.SET_FOUND_BLOGS](state, data) {
    state.foundBlogs = []
    if (data) {
      if (data !== '') {
        state.foundBlogs = data
      }
    }
  },
  [types.SET_COMMENTS](state, data) {
    state.comments = []
    if (data) {
      if (data !== '') {
        state.comments = data
        if (Array.isArray(data)) {
          let blog = data[0].blog
          let found = state.blogs.find(x => parseInt(x.blog) === parseInt(blog))
          if (found) {
            found.countComments = data.length
          }
        }
      }
    }
  },
  [types.SET_ATTACHMENTS](state, data) {
    state.attachments = []
    if (data) {
      if (data !== '') {
        state.attachments = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/blog/mutations.js